export type UserOrganizationSummary = {
  id: string;
  name: string;
  business_type_code: string | null;
  is_owner: boolean;
  is_active: boolean;
  is_grant: boolean;
  grant_role: string | null;
};

export type ListMyOrganizationsPayload = {
  active_organization_id: string | null;
  organizations: UserOrganizationSummary[];
};

/** Parse tolerante del payload de `list_my_organizations` (RPC o embebido en bootstrap). */
export function parseListMyOrganizationsPayload(raw: unknown): ListMyOrganizationsPayload | null {
  if (raw == null || typeof raw !== 'object' || Array.isArray(raw)) return null;
  const obj = raw as Record<string, unknown>;
  const active =
    typeof obj.active_organization_id === 'string' ? obj.active_organization_id : null;
  const orgsRaw = obj.organizations;
  if (!Array.isArray(orgsRaw)) {
    return { active_organization_id: active, organizations: [] };
  }
  const organizations: UserOrganizationSummary[] = orgsRaw
    .map((row) => {
      if (row == null || typeof row !== 'object' || Array.isArray(row)) return null;
      const r = row as Record<string, unknown>;
      const id = typeof r.id === 'string' ? r.id : null;
      if (!id) return null;
      return {
        id,
        name: typeof r.name === 'string' ? r.name : 'Mi negocio',
        business_type_code:
          typeof r.business_type_code === 'string' ? r.business_type_code : null,
        is_owner: r.is_owner === true,
        is_active: r.is_active === true,
        is_grant: r.is_grant === true,
        grant_role: typeof r.grant_role === 'string' ? r.grant_role : null,
      };
    })
    .filter((x): x is UserOrganizationSummary => x != null);
  return { active_organization_id: active, organizations };
}
